import React, { Component } from 'react';
import { Row, Col, FormGroup, FormControl } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from './Contents/CreditNameLikeness';

export default class CreditNameLikeness extends Component {
  options = () => ({
    creditTitle: this.props.creditTitle || '',
  });

  handleContent(type, index) {
    const options = this.options();
    options[type] = index;
    this.props.updateBlock(this.props.block.id, getContent(options), options);
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          <Col sm={12}>
            <p className="question">How will the Producer be credited?</p>
            <FormGroup className="answer">
              <FormControl
                type="text"
                placeholder="enter the credit to be provided here (e.g. Produced By Johnny Jay)"
                value={this.props.creditTitle ? this.props.creditTitle : ''}
                onChange={(e) =>
                  this.handleContent('creditTitle', e.target.value)
                }
              />
            </FormGroup>
          </Col>

          <Col sm={12}>{this.props.children}</Col>

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  A credit acknowledges the Producer for their contribution to
                  the master(s) (e.g. “written by, produced by, etc.”).
                  Providing credit can include publicly listing their name,
                  likeness, logos, trademarks, monikers, biographical
                  information, and their role in the creation of the master(s).
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/ContractBlock/CreditNameLikeness.jsx